import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

export const useDeviceType = () => {
  const isMobile = useMediaQuery({ maxWidth: 1199 });
  const isPad = useMediaQuery({ minWidth: 560, maxWidth: 1199 });
  const isTablet = useMediaQuery({ minWidth: 1200, maxWidth: 1919 });
  const isDesktop = useMediaQuery({ minWidth: 1920 });

  const [screenWidth, setScreenWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 0
  );

  const [screenHeight, setScreenHeight] = useState(
    typeof window !== 'undefined' ? window.innerHeight : 0
  );

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setScreenHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isMobile,
    isPad,
    isTablet,
    isDesktop,
    screenWidth,
    screenHeight,
  };
};
